import classNames from "classnames";
import React, { useMemo } from "react";
import { FinancingModalTrigger } from "tsi-common-react/src/apps/financing/FinancingModalTrigger";
import Trans from "tsi-common-react/src/common/Trans";
import { getDefaultFinancingPlan } from "tsi-common-react/src/utils/financing";
import { formatFinancingPlan } from "tsi-common-react/src/utils/format";
import { c, t } from "ttag";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import tempurCcSmall from "../../img/finance/tempur-cc-small.png";

import styles from "./FinancingModalTriggerRetailModalPreapproval.module.scss";

interface IProps {
    onRequestParentClose?: () => void;
}

const iconClasses = classNames({
    [styles.preApprovalAdIcon]: true,
    [styles.preApprovalAdIconFinance]: true,
    [styles.preApprovalAdIconCard]: true,
});

const buttonClasses = concatClassNames([
    "button",
    styles.preApprovalAdButton,
    "pre-approval-ad__apply",
    "al-financing-page__pre-approval-ad--apply-now",
    "al-financing-page__pre-approval-ad--apply-now-desktop",
]);

export const FinancingModalTriggerRetailModalPreapproval = (props: IProps) => {
    const plan = useMemo(
        () => formatFinancingPlan(getDefaultFinancingPlan()),
        [],
    );
    const onOpen = () => {
        if (props.onRequestParentClose) {
            props.onRequestParentClose();
        }
    };
    return (
        <span>
            <div className={styles.root}>
                <img
                    className={iconClasses}
                    // TODO(i18n): Wrap alt text in t tagged template: alt={t`Tempur-Pedic Credit Card`}
                    alt="Tempur-Pedic Credit Card"
                    src={tempurCcSmall}
                />
                <div className={styles.terms}>
                    <div
                        className={concatClassNames([
                            styles.termsLine,
                            styles.termsLine1,
                        ])}
                    >
                        {/* TODO(i18n): Translate complete sentence together, not in fragments. Use single t template: {c("FinancingModalTriggerRetailModalPreapproval").t`${plan.apr} APR for ${plan.length} Months`} */}
                        {t`${plan.apr} APR`}
                    </div>
                    <div
                        className={concatClassNames([
                            styles.termsLine,
                            styles.termsLine2,
                        ])}
                    >
                        {t`for `}
                        <div className={styles.lineRule}></div>
                    </div>
                    <div
                        className={concatClassNames([
                            styles.termsLine,
                            styles.termsLine3,
                        ])}
                    >
                        {c("FinancingModalTriggerRetailModalPreapproval")
                            .t`${plan.length} Months`}
                        <sup>
                            <a href="/finance-your-purchase#terms_and_conditions">
                                {plan.superscript}
                            </a>
                        </sup>
                    </div>
                </div>
                <div className={styles.see}>
                    {/* TODO(i18n): Translate complete sentence together. Combine into single t template: {t`Check if you're pre-qualified without affecting your credit score.`} */}
                    <div className={styles.seeBold}>
                        {t`Check if you're pre-qualified`}
                    </div>
                    <div className={styles.seeSmall}>
                        {t`without affecting your credit score.`}
                    </div>
                </div>
                <FinancingModalTrigger
                    modalType="prequal-app"
                    className={buttonClasses}
                    title={t`Check Now`}
                    onClick={onOpen}
                >
                    {t`Check Now`}
                </FinancingModalTrigger>
            </div>
            <div className={concatClassNames([styles.root, styles.mobile])}>
                <div className={styles.terms}>
                    <div
                        className={concatClassNames([
                            styles.termsLine,
                            styles.termsLine1,
                        ])}
                    >
                        {c("FinancingModalTriggerRetailModalPreapproval")
                            .t`${plan.apr} APR for ${plan.length} Months`}
                        <sup>
                            <a href="/finance-your-purchase#terms_and_conditions">
                                {plan.superscript}
                            </a>
                        </sup>
                    </div>
                </div>
                <div className={styles.see}>
                    <div className={styles.seeSmall}>
                        <Trans
                            fmtString={t`Check if you <PrequalCopy>pre-qualify</PrequalCopy> without affecting your credit score.`}
                            data={{
                                PrequalCopy: (content) => (
                                    <FinancingModalTrigger
                                        key="1"
                                        modalType="prequal-app"
                                        title={t`Check Now`}
                                        onClick={onOpen}
                                    >
                                        {content}
                                    </FinancingModalTrigger>
                                ),
                            }}
                        />
                    </div>
                </div>
            </div>
        </span>
    );
};
